<mat-dialog-content>

  @if (isRetrievingOwnedAddresses) {
    <div class="flex justify-start content-center items-center">
      <div><mat-spinner diameter="18"></mat-spinner></div>
      <div class="ml2"> {{ 'Owned addresses are being retrieved' | translate }}</div>
    </div>
  }


  @if (!isRetrievingOwnedAddresses && !isRetrievingOwners && owners.length === 0) {
    @if (!enterAddressManually) {
      <h3 translate="">Owned addresses</h3>
      @for (address of ownedAddresses | slice:0:5; track address) {
        <div class="mt1 flex justify-between content-center items-center flex-row">
          <div>{{ getAddressLine(address) }}</div>
          <div>
            <button mat-flat-button="" color="primary" [disabled]="isRetrievingOwners" (click)="retrieveOwnersForOwnedAddress(address)">
              <span translate="">
                Check owners of this address
              </span>
            </button>
          </div>
        </div>
      }
      <div class="mt2">
        <a style="text-decoration: underline; color:blue; cursor: pointer;" (click)="enterAddressManually = true" translate="">
          or enter an address manually
        </a>
      </div>
    }
    @if (enterAddressManually) {
      <h3 translate="">Enter an address this customer owns</h3>
      <form [formGroup]="addressFormGroup">
        <unite-address-input-v2 class="mt2 flex flex-col" formGroupName="address" [disableManualEnter]="true">
        </unite-address-input-v2>
      </form>
      @if (!retrievedOwners) {
        <unite-loading-button [disabled]="!isValidAddress && isRetrievingOwners" [loading]="isRetrievingOwners" [text]="'Retrieve owners' | translate" (click)="retrieveOwnersForManualAddress()">
        </unite-loading-button>
      }
    }
  }

  @if (!isRetrievingOwners && noOwnersFound) {
    <div style="color: red" translate="">
      No owners found
    </div>
  }

  @if (isRetrievingOwners) {
    <div class="flex justify-start content-center items-center">
      <div><mat-spinner diameter="18"></mat-spinner></div>
      <div class="ml2" translate="">Owners are being retrieved</div>
    </div>
  }

  @if (!isRetrievingOwners && owners.length > 0) {
    <div class="mt2">
      <h3 translate="">Found cadastral owners</h3>
      <em>{{ retrievingOwnersForAddress }} </em>
      @for (owner of owners; track owner) {
        <div class="mt1 flex justify-between content-center items-center flex-row">
          <div>{{ owner.name }}</div>
          <div>
            <button mat-flat-button="" color="primary" (click)="connect(owner.cadastralId)">
              <span translate="">
                Connect to this customer
              </span>
            </button>
          </div>
        </div>
      }
    </div>
  }

</mat-dialog-content>